<template>
  <v-container fluid v-if="!isMobile">
    <nav>
      <v-app-bar app prominent dense>
        <v-container class="d-flex justify-center">
          <DateTimePicker :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :selectD="selectD" :isClose="isClose" />
        </v-container>
        <div style="padding-top:10px" class="d-flex">
          <v-btn class="mr-2" color="info darken-1" small fab v-if="resetTimeRange" @click="resetTrange(handleFetchSmp)">
            <v-icon color="white">mdi-restart</v-icon>
          </v-btn>
          <v-btn v-on="on" color="info" small fab @click="darkMode">
            <v-icon color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </nav>

    <v-data-iterator :items="smp" :items-per-page.sync="itemsPerPage" :page.sync="page" :search="search" :sort-by="sortBy.toLowerCase()" :sort-desc="sortDesc" hide-default-footer>
      <template v-slot:header>
        <v-toolbar dark color="blue darken-3" class="mb-1">
          <v-text-field v-model="search" clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Search by Unit ID, Location, Serial Number"></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select v-model="sortBy" clearable flat solo-inverted hide-details :items="keys" prepend-inner-icon="mdi-sort" label="Sort by"></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="sortDesc" mandatory>
              <v-btn large depressed color="blue" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn large depressed color="blue" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col v-for="item in props.items" :key="item._id" cols="12" sm="6" md="4" lg="3">
            <v-card elevation="5">
              <v-card @click="consoleRouter(item._id)">
                <v-card-title class="d-flex align-center justify-center" style="font-size: 12.0pt;"> {{ item._id }} | {{ item.location }} </v-card-title>
                <v-card-subtitle class="d-flex align-center justify-center" style="font-size: 9.0pt;">[S/N: {{ item.sn }}]</v-card-subtitle>
                <v-divider></v-divider>

                <v-simple-table id="mytable" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td style="background: rgba(138, 131, 131, 0.348);">Activity</td>
                        <td style="background: rgba(138, 131, 131, 0.348);">
                          Status <v-icon v-if="lastOnline(item.timestamp) < 10" color="green">mdi-circle</v-icon>
                          <v-icon v-else>mdi-circle</v-icon>
                        </td>
                      </tr>
                      <tr>
                        <td>Seismic</td>
                        <td v-if="item.seismic_event > 0" style="color: red;">Alert(s) {{ item.seismic_event }}</td>
                        <td v-else style="color: green;">OK</td>
                      </tr>
                      <tr>
                        <td>Noise</td>
                        <td v-if="item.sound_event > 0" style="color: red;">Alert(s) {{ item.sound_event }}</td>
                        <td v-else style="color: green;">OK</td>
                      </tr>
                      <tr>
                        <td>Dust(PM2.5)</td>
                        <td v-if="item.dust_event > 0" style="color: red;">Alert(s) {{ item.dust_event }}</td>
                        <td v-else style="color: green;">OK</td>
                      </tr>
                      <tr>
                        <td>Hazardous Gas</td>
                        <td v-if="item.gas_event > 0" style="color: red;">Alert(s) {{ item.gas_event }}</td>
                        <td v-else style="color: green;">OK</td>
                      </tr>
                      <tr>
                        <td>Weather</td>
                        <td v-if="item.weather_event > 0" style="color: red;">Alert(s) {{ item.weather_event }}</td>
                        <td v-else style="color: green;">OK</td>
                      </tr>
                      <tr>
                        <td>Last Updated</td>
                        <td v-if="lastUpdate(item.timestamp).includes('ago') == true">{{ lastUpdate(item.timestamp) }}</td>
                        <td v-else>{{ lastUpdate(item.timestamp).substring(2) }} ago</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
              <br />
              <v-card>
                <template>
                  <div class="text-center">
                    <v-dialog width="1200" :eager="true">
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on">
                          <v-lazy v-if="renderComponent">
                            <HereMap :center="map(item.latitude, item.longitude)" :modal="false" />
                          </v-lazy>
                        </v-card>
                      </template>
                      <v-card style="z-index: 999999;">
                        <v-lazy>
                          <HereMap :center="map(item.latitude, item.longitude)" :modal="true" />
                        </v-lazy>
                      </v-card>
                    </v-dialog>
                  </div>
                </template>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-container>
          <v-row class="mt-2" align="center" justify="center">
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(number, index) in itemsPerPageArray" :key="index" @click="updateItemsPerPage(number)">
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer></v-spacer>

            <span
              class="mr-4
            grey--text"
            >
              Page {{ page }} of {{ numberOfPages }}
            </span>
            <v-btn fab dark color="blue darken-3" class="mr-1" @click="formerPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </v-container>
      </template>
    </v-data-iterator>
  </v-container>

  <v-container v-else>
    <v-row align="center" justify="center" class="fill-height">
      <v-container class="text-center">
        <DateTimePickerMobile :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :selectD="selectD" :isClose="isClose" />
      </v-container>
    </v-row>
    <OverviewMobileView :smp="smp" :renderComponent="renderComponent" />
  </v-container>
</template>

<script>
  // import axios from "axios";
  import moment from "moment";
  import { mapActions, mapGetters } from "vuex";
  import HereMap from "../../components/HereMap.vue";
  import OverviewMobileView from "../../components/OverviewMobileView.vue";
  import DateTimePicker from "../../components/DateTimePicker.vue";
  import DateTimePickerMobile from "../../components/DateTimePickerMobile.vue";
  import router from "../../router";

  class Event {
    constructor(name, value) {
      this.name = name;
      this.value = value;
      this.time = new Date();
    }
  }

  export default {
    components: {
      HereMap,
      OverviewMobileView,
      DateTimePicker,
      DateTimePickerMobile,
    },
    data: () => ({
      // resetTimerange: false,
      dialog: false,
      isClose: Boolean,
      clicked: 0,
      events: [],
      appItems: [
        {
          text: "Dashboard",
          disabled: true,
          href: "/",
        },
      ],
      renderComponent: true,
      itemsPerPageArray: [8, 12, 16],
      search: "",
      filter: {},
      polling: null,
      sortDesc: false,
      page: 1,
      itemsPerPage: 8,
      sortBy: "_id",
      keys: [
        { text: "Unit ID", value: "_id" },
        { text: "Location", value: "location" },
        { text: "Serial Number", value: "sn" },
        { text: "Last Updated", value: "timestamp" },
      ],
      isMobile: true,
      // smp: [],
      center: {
        lat: null,
        lng: null,
      },
    }),
    computed: {
      ...mapGetters(["smp", "dateTime1", "dateTime2", "resetTimeRange"]),
      numberOfPages() {
        return Math.ceil(this.smp.length / this.itemsPerPage);
      },
      filteredKeys() {
        return this.keys.filter((key) => key !== "Name");
      },
    },
    mounted() {
      this.handleFetchSmp();
      this.intervalFetchData();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });

      const theme = localStorage.getItem("dark_theme");
      if (theme) {
        if (theme === "true") {
          this.$vuetify.theme.dark = true;
        } else {
          this.$vuetify.theme.dark = false;
        }
      } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        this.$vuetify.theme.dark = true;
        localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
      }
    },
    methods: {
      ...mapActions(["fetchSmp", "resetTrange"]),
      handleFetchSmp() {
        this.fetchSmp();
        this.renderComponent = false;
        this.$nextTick(() => {
          this.renderComponent = true;
        });
      },
      dateApplied(date1, date2) {
        this.events.unshift(new Event("date-applied", `${date1.toString()}`));
        this.values1 = this.events[0].value;

        this.events.unshift(new Event("date-applied", `${date2.toString()}`));
        this.values2 = this.events[0].value;

        this.updateData(this.events);

        this.isClose = true;
        this.clicked = 0;
      },

      selectD(date1, date2) {
        this.clicked++;

        if (this.clicked === 2) {
          this.dateApplied(date1, date2);
          this.clicked = 0;
        }
      },

      darkMode() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },

      intervalFetchData: function() {
        this.polling = setInterval(() => {
          if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 60 && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(1, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.handleFetchSmp();
          } else if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 180 && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(3, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.handleFetchSmp();
          } else if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 720 && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(12, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.handleFetchSmp();
          } else {
            this.handleFetchSmp();
          }
        }, 60000);
      },
      lastUpdate(value) {
        return moment().from(moment(value));
      },
      lastOnline(value) {
        return moment().diff(moment(value), "minutes");
      },
      map(lat, lon) {
        return (this.center = {
          lat: lat,
          lng: lon,
        });
      },
      consoleRouter(value) {
        router.push("/details/" + value);
      },
      // loadsSmp: async function(){
      // let apiURL = process.env.VUE_APP_API + "/api/smp/overview/" + this.values1 + '-'+ this.values2
      // axios.get(apiURL).then(res => {
      // this.smp = res.data;
      // this.renderComponent = false;
      // this.$nextTick(() => {
      // this.renderComponent = true;
      //   });

      // }).catch(error => {
      // console.log(error)
      // });
      // },
      nextPage() {
        if (this.page + 1 <= this.numberOfPages) this.page += 1;
      },
      formerPage() {
        if (this.page - 1 >= 1) this.page -= 1;
      },
      updateItemsPerPage(number) {
        this.itemsPerPage = number;
      },

      updateData(values) {
        this.resetTimerange = true;
        this.$store.commit("setReset", this.resetTimerange);

        this.values1 = values[1].value;
        this.values2 = values[0].value;
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);

        if (moment(this.values2).diff(moment(this.values1), "minutes") == 60 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(1, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.handleFetchSmp();
        } else if (moment(this.values2).diff(moment(this.values1), "minutes") == 180 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(3, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.handleFetchSmp();
        } else if (moment(this.values2).diff(moment(this.values1), "minutes") == 720 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(12, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.handleFetchSmp();
        } else {
          this.values1 = values[1].value;
          this.values2 = values[0].value;
          this.handleFetchSmp();
        }
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
      clearInterval(this.polling);
    },
  };
</script>
